var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-wrapper"},[_c('ScPlaceholder',{attrs:{"name":"cards","rendering":_vm.rendering}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }